import { Component, OnInit, HostListener, Inject, OnDestroy, InjectionToken } from '@angular/core';
import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';

import { DataService, HelperService } from 'app/services';

import { environment } from 'environments/environment';

import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ScriptLoaderService } from './services/script-loader.service';

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => window,
});

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  routerEventSub: Subscription = null;
  routerEventNavSub: Subscription = null;
  isMultiLocationEnabled: boolean = false;
  cusomerFacingScreens: string = ['^#/customer-review', '^#/customer-appointment-request', '^#/print-view/sales-report', '^#/print-view/royalty-report-print' ,'^#/print-view/daily-payment-report', '^#/print-view/enhance-item-sold-print', '^#/print-view/item-sold-details-report-print', '^#/customer-feedback/customer', '^#/privacy-policy-template'].join('|');

  constructor(
    private router: Router,
    private titleService: Title,
    private scriptLoader: ScriptLoaderService,
    private helperService: HelperService,
    private dataService: DataService,
    @Inject(WINDOW) private _window: Window,
    @Inject(DOCUMENT) private _document: HTMLDocument
  ) {}

  ngOnInit() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    this.isMultiLocationEnabled = isMultiLocationEnabled;
    this.routerEventSub = this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) return;

      window.scrollTo(0, 0);
    });

    this.routerEventNavSub = this.router.events
      .pipe(
        filter((event) => event instanceof RoutesRecognized),
        map((event: RoutesRecognized) => {
          if (this.router.url && !this.router.url.includes('estimate')) {
            window.name = '';
          }
          //let child = this.activatedRoute.firstChild;
          if (event && event.state && event.state.root && event.state.root.firstChild) {
            let child = event.state.root.firstChild;
            while (child) {
              if (child.firstChild) {
                child = child.firstChild;
              } else if (child.data && child.data['title']) {
                return child.data['title'];
              } else {
                return null;
              }
            }
          }

          return null;
        })
      )
      .subscribe((data: any) => {
        if (data) {
          this.titleService.setTitle(data); // Here we can set additional string for title
        }
      });

    if (environment.ENV === 'qa') {
      this._document.getElementById('appFavicon').setAttribute('href', '../assets/favicon-qa.png');
    }

    if (this.isMultiLocationEnabled) {
      document.addEventListener('visibilitychange', this.handleShopAcl);
    }

    this.setOnSignalIntegration();
  }

  ngOnDestroy() {
    if (this.routerEventSub) {
      this.routerEventSub.unsubscribe();
    }

    if (this.routerEventNavSub) {
      this.routerEventNavSub.unsubscribe();
    }

    if (this.isMultiLocationEnabled) {
      document.removeEventListener('visibilitychange', this.handleShopAcl);
    }
  }

  setOnSignalIntegration() {
    if (environment.onesignal_external_script) {
      this.scriptLoader.loadScript('OneSignal').then(
        () => {
          const { OneSignal = [] } = this._window as any;
          OneSignal.push(function () {
            OneSignal.init({
              appId: environment.onesignal_api_key,
            });
          });
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  handleShopAcl = (event: any) => {
    const currentShopId = localStorage.getItem('currentShop');

    if (document.visibilityState === 'visible' && currentShopId && this.dataService.currentShopId !== currentShopId) {
      if (new RegExp(this.cusomerFacingScreens).test(location.hash)){
        return;
      } else {
        window.location.reload();
      }

    }
  };

  @HostListener('document:click', ['$event'])
  documentClick(event: any): void {
    this.dataService.sendClickEvent(event.target);
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    this.dataService.sendKeyPressEvent(event);
  }
}
